import { ReactNode, useCallback, useState } from 'react';
import { PreventUpdatingContext } from './context';

export const PreventUpdatingProvider = ({ children }: { children: ReactNode }) => {
  const [updatingCounter, setUpdatingCounter] = useState(0);

  const preventUpdate = useCallback(async (apiCall: () => Promise<unknown>) => {
    try {
      setUpdatingCounter((count) => count + 1);
      await apiCall();
    } finally {
      setUpdatingCounter((count) => count - 1);
    }
  }, []);

  return (
    <PreventUpdatingContext.Provider value={{ preventUpdate, isUpdating: updatingCounter !== 0 }}>
      {children}
    </PreventUpdatingContext.Provider>
  );
};
